module.exports = __webpack_public_path__ + "img/file-download-03.eba3f181.svg";